import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  [
    'font-nista-grotesk flex cursor-pointer items-center justify-center gap-2 border-1 border-solid text-[14px] leading-4 font-medium tracking-[-0.3px] transition duration-200 ease-in-out',
    'focus-visible:outline-info-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4',
    'disabled:cursor-not-allowed'
  ],
  {
    variants: {
      variant: {
        primary: [
          'bg-charcoal-500 text-white-50 border-transparent',
          'hover:bg-charcoal-900 active:bg-charcoal-900',
          'disabled:bg-charcoal-50 disabled:text-charcoal-200'
        ],
        secondary: [
          'bg-cloud-300 text-charcoal-500 border-transparent',
          'hover:bg-cloud-500 active:bg-cloud-500',
          'disabled:bg-charcoal-50 disabled:text-charcoal-200'
        ],
        tertiary: [
          'text-charcoal-500 border-transparent bg-transparent',
          'hover:bg-charcoal-alpha-50 active:bg-charcoal-alpha-50',
          'disabled:text-charcoal-200'
        ],
        quaternary: [
          'bg-spring-yellow-500 text-charcoal-500 border-transparent',
          'hover:bg-spring-yellow-200 active:bg-spring-yellow-200',
          'disabled:bg-charcoal-50 disabled:text-charcoal-200'
        ],
        outline: [
          'text-charcoal-500 border-stone-100',
          'hover:bg-charcoal-alpha-50 active:bg-charcoal-alpha-50',
          'disabled:text-charcoal-200 disabled:border-stone-100'
        ]
      },
      size: {
        xsmall: 'py-1-5 gap-2 rounded-md px-3',
        small: 'gap-2 rounded-md px-3 py-2',
        medium: 'gap-2 rounded-lg px-4 py-3',
        icon: 'rounded-full p-1'
      },
      fullWidth: {
        true: 'w-full',
        false: 'w-auto'
      }
    },
    defaultVariants: {
      variant: 'primary',
      fullWidth: false,
      size: 'medium'
    }
  }
);
